"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetMultiInputEmptyErrors = exports.getMultiInputInnerIds = exports.MultiInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Cloner = _interopRequireDefault(require("../../utils/Cloner"));
var _Finder = _interopRequireDefault(require("../../common/Finder"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.multi-input {\n  background: #d4d4d4;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n  width: 100%; }\n  .multi-input .required {\n    margin-bottom: 16px;\n    font-size: 16px;\n    display: block; }\n  .multi-input .error {\n    color: #e41b13;\n    margin-bottom: 1rem; }\n  .multi-input .tooltip {\n    color: #a8a8a8; }\n  .multi-input > div:last-child {\n    margin: 0; }\n";
  const fileName = "MultiInput_MultiInput";
  const element = document.querySelector("style[data-sass-component='MultiInput_MultiInput']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const MultiInput = props => {
  const onBlur = e => {
    if (!e.currentTarget.contains(e.relatedTarget) && props.onBlur) {
      props.onBlur(e);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: props.id,
    className: 'multi-input',
    onBlur: onBlur
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: 'required'
  }, props.translate('form.multi-input.required'), props.tooltip && /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip sia-padding-01-top sia-padding-01-bottom"
  }, props.tooltip)), props.invalidText && /*#__PURE__*/_react.default.createElement("div", {
    className: 'error'
  }, props.invalidText), props.children);
};
exports.MultiInput = MultiInput;
const resetMultiInputEmptyErrors = (errors, id, inputIds) => {
  const newErrors = _Cloner.default.clone(errors);
  newErrors[id] = null;
  inputIds.forEach(inputId => {
    const error = errors[inputId];
    if (error === 'form.input.error.empty') {
      newErrors[inputId] = null;
    }
  });
  return newErrors;
};
exports.resetMultiInputEmptyErrors = resetMultiInputEmptyErrors;
const getMultiInputInnerIds = id => {
  const element = document.querySelector(`#${id}`);
  return _Finder.default.getIdsRecursive(element.children);
};
exports.getMultiInputInnerIds = getMultiInputInnerIds;
MultiInput.propTypes = {
  id: _propTypes.default.string.isRequired,
  translate: _propTypes.default.func.isRequired,
  invalidText: _propTypes.default.string,
  type: _propTypes.default.string,
  tooltip: _propTypes.default.string
};
MultiInput.defaultProps = {
  type: 'MultiInput',
  // todo, https://stackoverflow.com/q/72446985/4840661
  required: true
};